module.exports = __webpack_public_path__ + "static/media/cw_user_dashboard.09e6e841.png";